<div class="container-fluid">
  <page-header-breadcrumb
  [pageTitleValue]="pageTitle"
  [pageLinkValue]="'/geo/cities'"
  [currentPageValue]="editMode ? 'Edit City' : 'Add City'"
></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addCityForm" (ngSubmit)="onAddCitySubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="city-name">
                City EN Name
              </label>
              <input
                class="form-control"
                id="city-name"
                formControlName="enCityName"
                placeholder="City Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addCityForm.controls.enCityName.dirty) &&
                  addCityForm.controls.enCityName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCityForm.controls.enCityName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addCityForm.controls.enCityName.errors.pattern">
                  This field accept only english characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="city-ar-name">
                City AR Name
              </label>
              <input
                class="form-control"
                id="city-ar-name"
                formControlName="arCityName"
                placeholder="City Arabic Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addCityForm.controls.arCityName.dirty) &&
                  addCityForm.controls.arCityName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCityForm.controls.arCityName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addCityForm.controls.arCityName.errors.pattern">
                  This field accept only arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col">
            <div class="form-group d-flex align-items-center">
              <label class="mr-6 mb-0" for="active-check">Active ?</label>
              <label class="custom-toggle custom-toggle-default">
                <input
                  checked="checked"
                  type="checkbox"
                  id="active-check"
                  formControlName="cityActiveCheck"
                />
                <span
                  class="custom-toggle-slider rounded-circle"
                  data-label-off="No"
                  data-label-on="Yes"
                >
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addCityForm.invalid"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/geo/cities'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
